import { createContext, useContext, useEffect, useState } from 'react';

const MusicGateContext = createContext({ unlocked: false, unlock: () => {} });

const STORAGE_KEY = 'stillfaded:music-unlocked';

export const MusicGateProvider = ({ children }) => {
    const [unlocked, setUnlocked] = useState(false);

    useEffect(() => {
        try {
            if (sessionStorage.getItem(STORAGE_KEY) === '1') {
                setUnlocked(true);
            }
        } catch {
            // sessionStorage unavailable (private mode); gate will still show
        }
    }, []);

    const unlock = () => {
        try {
            sessionStorage.setItem(STORAGE_KEY, '1');
        } catch {
            // ignore
        }
        setUnlocked(true);
    };

    return (
        <MusicGateContext.Provider value={{ unlocked, unlock }}>
            {children}
        </MusicGateContext.Provider>
    );
};

export const useMusicGate = () => useContext(MusicGateContext);
